import {parseResponse} from "../../components/bn_forms";

$(document).on('click', '.bn_collections__get-create-popup', function () {
    $.ajax({
        'type': 'POST',
        'dataType': 'json',
        'beforeSend': function () {
            $('#bn_collections__create').remove();
        },
        'success': function (response) {
            parseResponse(response);

            initializeInputCounters();

            openPopup('#bn_collections__create');
        },
        'url': '/account/lib/collections/create'
    });
})

$(document).on('click', '.bn_collections__get-dynamic-create-popup', function () {
    let that = $(this),
        wrapper = that.parents('#bn_shelves'),
        bookId = wrapper.data('id'),
        title = wrapper.find('.bn_collections__get-create-popup-input').val();

    $.ajax({
        'type': 'POST',
        'dataType': 'json',
        'data': {
            title: title,
            bookId: bookId,
        },
        'beforeSend': function () {
            $('#bn_collections__create').remove();
        },
        'success': function (response) {
            parseResponse(response);

            initializeInputCounters();

            openPopup('#bn_collections__create');
        },
        'url': '/account/lib/collections/dynamic-create'
    });
})

$(document).on('click', '.bn_collections__get-update-popup', function () {
    let that = $(this),
        id = that.data('id');

    $.ajax({
        'type': 'POST',
        'dataType': 'json',
        'data': {id: id},
        'beforeSend': function () {
            $('#bn_collections__create').remove();
        },
        'success': function (response) {
            parseResponse(response);

            initializeInputCounters();

            openPopup('#bn_collections__create');
        },
        'url': '/account/lib/collections/update'
    });
})

$(document).on('click', '.bn_collections__get-delete-popup', function () {
    let that = $(this);

    $.ajax({
        'type': 'POST',
        'dataType': 'json',
        'beforeSend': function () {
            $('#bn_collections__delete').remove();
        },
        'success': function (response) {
            parseResponse(response);

            openPopup('#bn_collections__delete');
        },
        'url': '/account/lib/collections/get-delete-popup?id=' + that.data('id')
    });
})

$(document).on('change', '.bn_collections__select-type', function () {
    let that = $(this),
        wrapper = that.parents('.bn_popup'),
        content = wrapper.find('.bn_library-collections__popup-create-form-content');

    if (parseInt(that.val())) {
        content.removeClass('disabled')
    } else {
        content.addClass('disabled')

        if (wrapper.hasClass('public')) {
            $.ajax({
                'type': 'POST',
                'dataType': 'json',
                'beforeSend': function () {
                    $('#bn_collections__change').remove();
                },
                'success': function (response) {
                    parseResponse(response);

                    openPopup('#bn_collections__change');
                },
                'url': '/account/lib/collections/get-change-type-popup'
            });
        }
    }
})

$(document).on('click', '.bn_collections__close-change-popup', function () {
    $('#type1').prop('checked', true);

    $('.bn_library-collections__popup-create-form-content').removeClass('disabled');

    closePopup('#bn_collections__change');
})

$(document).on('click', '.bn_collections__submit-change-popup', function () {
    $(this).addClass('spin');

    $('.bn_library-collections__popup-create-form').submit();

    closePopup('#bn_collections__change');
})

$(document).on('click', '.bn_library-collections__view-navigation-item', function() {
    let that = $(this),
        target = that.data('target');

    $('.bn_library-collections__view-navigation-item').removeClass('active');

    that.addClass('active')

    $('.bn_library-collections__view-tab').removeClass('active');

    $('#'+target).addClass('active');
});

$(document).on('click', '.bn_collections__like', function () {
    let that = $(this),
        active = that.hasClass('active'),
        id = that.parents('.bn_library-collections__view').data('id'),
        url = '/collections/add-like';

    if (active) {
        url = '/collections/remove-like';
    }

    $.ajax({
        type: 'POST',
        url: url,
        data: {collectionId: id},
        success: function () {
            let counter = that.find('.counter'),
                value = counter.text(),
                number = value.replace(/ /g, ''),
                integer = parseInt(number) - 1;

            if (active) {
                that.removeClass('active');
            } else {
                that.addClass('active');
                integer = parseInt(number) + 1;
            }

            counter.text(integer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "));
        },
    });
});

$(document).on('change', '.bn_library-collections__change-collection', function () {
    let that = $(this),
        wrapper = that.parents('#bn_shelves'),
        bookId = wrapper.data('id'),
        collectionId = that.data('id'),
        url = '/account/lib/collections/remove-book',
        counter = that.parents('.bn_library-collections__swiper-collection-item').find('.counter'),
        integer = parseInt(counter.text()) - 1;

    if (that.is(':checked')) {
        url = '/account/lib/collections/add-book';
        integer = parseInt(counter.text()) + 1;
    }

    $.ajax({
        type: 'POST',
        url: url,
        data: {
            bookId: bookId,
            collectionId: collectionId,
        },
        success: function (response) {
            counter.text(integer);

            flashNotify(response.message);
        },
    });
})

$(document).on('click', '.bn_library-collections__add-note', function () {
    let that = $(this),
        wrapper = that.parents('.bn_library-collections__view-books-list-item'),
        body = that.parents('.bn_library-collections__view'),
        bookId = wrapper.data('id'),
        collectionId = body.data('id');

    $.ajax({
        type: 'POST',
        data: {
            bookId: bookId,
            collectionId: collectionId,
        },
        'beforeSend': function () {
            $('#bn_collections__note').remove();
        },
        success: function (response) {
            parseResponse(response);

            initializeInputCounters();

            openPopup('#bn_collections__note');
        },
        url: '/account/lib/collections/note'
    });
})

$(document).on('click', '.bn_library-collections__popup-note-delete', function () {
    $('#collectionnoteform-note').val('');

    $('.bn_library-collections__popup-note-form').submit();
})

$(document).on('click', '.bn_library-collections__get-remove-book-popup', function () {
    let that = $(this),
        wrapper = that.parents('.bn_library-collections__view-books-list-item'),
        body = that.parents('.bn_library-collections__view'),
        bookId = wrapper.data('id'),
        collectionId = body.data('id');

    $.ajax({
        type: 'POST',
        data: {
            bookId: bookId,
            collectionId: collectionId,
        },
        'beforeSend': function () {
            $('#bn_collections__book-remove').remove();
        },
        success: function (response) {
            parseResponse(response)

            openPopup('#bn_collections__book-remove')
        },
        url: '/account/lib/collections/get-remove-book-popup'
    });
})

$(document).on('change', '.bn_library-collections__change-shelf', function () {
    let that = $(this),
        destinationId = that.data('destination'),
        wrapper = that.parents('.wrapper'),
        bookId = wrapper.data('id');

    $.ajax({
        type: 'POST',
        url: '/account/lib/collections/change-shelf',
        data: {
            bookId: bookId,
            destinationId: destinationId,
        },
        success: function (response) {
            flashNotify(response.message)
        },
    });
})

$(document).on('click', '.bn_library-collections__move-archive', function () {
    let that = $(this),
        destinationId = that.data('destination'),
        wrapper = that.parents('#bn_collections__library-remove'),
        bookId = wrapper.data('id');

    $.ajax({
        type: 'POST',
        url: '/account/lib/collections/change-shelf',
        data: {
            bookId: bookId,
            destinationId: destinationId,
        },
        success: function (response) {
            window.location.reload();
        },
    });
})

$(document).on('click', '.bn_collections__get-shelves-swiper', function () {
    openShelfSwiper($(this).data('id'), true);
})

$(document).on('click', '.bn_library-collections__popup-add-auto-delete', function () {
    let that = $(this),
        wrapper = that.parents('.wrapper');

    removeBookFromLibrary(wrapper.data('id'));

    closePopup('#bn_collections__add-auto-library');
})

$(document).on('click', '.bn_collections__get-shelves-popup', function () {
    openShelfPopup($(this).data('id'), true);
})

$(document).on('click', '.bn_library-collections__library-remove', function () {
    let that = $(this),
        wrapper = that.parents('#bn_shelves');

    getRemoveFromLibraryPopup(wrapper.data('id'));
});

$(document).on('click', '.bn_library-collections__book-move-up', function () {
    let that = $(this),
        wrapper = that.parents('.bn_library-collections__view');

    $.ajax({
        'type': 'POST',
        'dataType': 'json',
        'data': {
            collectionId: wrapper.data('id'),
            bookId: that.data('id'),
        },
        'success': function () {
            window.location.reload();
        },
        'url': '/account/lib/collections/move-book-up'
    });
})

$(document).on('click', '.bn_library-collections__book-move-down', function () {
    let that = $(this),
        wrapper = that.parents('.bn_library-collections__view');

    $.ajax({
        'type': 'POST',
        'dataType': 'json',
        'data': {
            collectionId: wrapper.data('id'),
            bookId: that.data('id'),
        },
        'success': function () {
            window.location.reload();
        },
        'url': '/account/lib/collections/move-book-down'
    });
})

window.getRemoveFromLibraryPopup = function (bookId) {
    $.ajax({
        'type': 'POST',
        'dataType': 'json',
        'data': {bookId: bookId},
        'beforeSend': function () {
            $('#bn_collections__library-remove').remove();
        },
        'success': function (response) {
            parseResponse(response);

            openPopup('#bn_collections__library-remove');
        },
        'url': '/account/lib/collections/get-library-remove-popup'
    });
}

window.removeBookFromCollection = function (collectionId, bookId) {
    $.ajax({
        type: 'POST',
        data: {
            bookId: bookId,
            collectionId: collectionId,
        },
        success: function (response) {
            window.location.reload();
        },
        url: '/account/lib/collections/remove-book'
    });
}

window.addBookInLibrary = function (bookId, auto) {
    $.ajax({
        type: 'POST',
        url: '/book/to-library',
        data: {
            bookId: bookId,
            auto: auto,
        },
        dataType: 'json',
        success: function (response) {
            parseResponse(response);
        },
    });
}

window.removeBookFromLibrary = function (bookId, reload) {
    $.ajax({
        type: 'POST',
        url: '/book/from-library',
        data: {
            bookId: bookId
        },
        dataType: 'json',
        success: function () {
            if (reload) {
                window.location.reload();
            }
        },
    });
}

window.openShelfSwiper = function (bookId, reload) {
    $.ajax({
        'type': 'POST',
        'dataType': 'json',
        'data': {
            bookId: bookId,
            reload: reload
        },
        'beforeSend': function () {
            $('#bn_shelves').remove();
        },
        'success': function (response) {
            parseResponse(response);

            initializeInputCounters();

            openSwiper('#bn_shelves');
        },
        'url': '/account/lib/collections/get-shelves-popup'
    });
}

window.openShelfPopup = function (bookId, reload) {
    $.ajax({
        'type': 'POST',
        'dataType': 'json',
        'data': {
            bookId: bookId,
            reload: reload,
        },
        'beforeSend': function () {
            $('#bn_shelves').remove();
        },
        'success': function (response) {
            parseResponse(response);

            initScrollbar();

            initializeInputCounters();

            openPopup('#bn_shelves');
        },
        'url': '/account/lib/collections/get-shelves-popup'
    });
}

window.closeDynamicCreation = function () {
    closePopup('#bn_collections__create');

    $('.bn_library-collections__swiper-collections-empty').remove();

    $('.bn_collections__get-create-popup-input').val('');

    $('.bn_library-collections__swiper-input').removeClass('filled');
};

window.openAddAutoLibraryPopup = function (bookId) {
    console.log('asdasd');

    $.ajax({
        'type': 'POST',
        'dataType': 'json',
        'data': {bookId: bookId},
        'beforeSend': function () {
            $('#bn_collections__add-auto-library').remove();
        },
        'success': function (response) {
            console.log('asdasd');
            parseResponse(response);

            openPopup('#bn_collections__add-auto-library');
        },
        'url': '/account/lib/collections/get-add-auto-library-popup'
    });
}